import { render, staticRenderFns } from "./comTitle.vue?vue&type=template&id=07f8a68e&scoped=true"
import script from "./comTitle.vue?vue&type=script&lang=js"
export * from "./comTitle.vue?vue&type=script&lang=js"
import style0 from "./comTitle.vue?vue&type=style&index=0&id=07f8a68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8a68e",
  null
  
)

export default component.exports